<div class="flex flex-col gap-2">
  <div class="w-full">
    <label class="block text-sm font-medium text-gray-700 mb-1">Desconto em Valor (R$)</label>
    <p-inputNumber
      [(ngModel)]="discountValue"
      (onInput)="onDiscountValueChange()"
      currency="BRL"
      locale="pt-BR"
      mode="currency"
      [inputStyle]="{ width: '100%' }"
      [min]="0"
      [max]="grossTotal"
      class="w-full"
      id="discount-value-input"
      placeholder="0,00">
    </p-inputNumber>
  </div>

  <div class="w-full">
    <label class="block text-sm font-medium text-gray-700 mb-1">Desconto em Percentual (%)</label>
    <p-inputNumber
      [(ngModel)]="discountPercent"
      (onInput)="onDiscountPercentChange()"
      [inputStyle]="{ width: '100%' }"
      [min]="0"
      [max]="100"
      suffix="%"
      class="w-full"
      id="discount-percent-input"
      placeholder="0">
    </p-inputNumber>
  </div>

  <div class="text-xs text-gray-500 mb-2">
    <p *ngIf="grossTotal > 0">Total bruto: {{ grossTotal | currency:'BRL' }}</p>
    <p *ngIf="discountValue !== null && discountValue > 0">
      Desconto aplicado: {{ discountValue | currency:'BRL' }}
    </p>
    <p *ngIf="discountPercent !== null && discountPercent > 0">
      Desconto aplicado: {{ (grossTotal * discountPercent / 100) | currency:'BRL' }} ({{ discountPercent }}%)
    </p>
  </div>

  <div class="w-full mt-2">
    <button (click)="confirmDiscount()"
            pButton
            type="button"
            label="Confirmar (Enter)"
            class="w-full bg-orange-600 hover:bg-orange-700 text-white">
    </button>
  </div>
</div>

